/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { isPointInsideDocumentView } from "selectors/documentViewSelectors";
import { PinchZoomEnabler } from "./PinchZoomEnabler";

class WebKitPinchZoomEnabler extends PinchZoomEnabler {
  constructor(event) {
    super(event);
    this.clientX = event.clientX;
    this.clientY = event.clientY;
    this.initialZoomLevel = 1;
  }

  setScaleFactor(event, initialZoomLevel) {
    this.initialZoomLevel = initialZoomLevel;
  }

  isEventToBeConsumendByEnabler({ type }) {
    return type.startsWith("gesture");
  }

  getNewZoomLevel(event) {
    return this.initialZoomLevel * event.scale;
  }

  getCenterX(event) {
    return event.clientX;
  }

  getCenterY(event) {
    return event.clientY;
  }

  shouldStartPinchZoom(event, stores) {
    return isPointInsideDocumentView(stores, event.clientX, event.clientY);
  }
}

export { WebKitPinchZoomEnabler };
